import React from 'react';
import { NavLink } from 'react-router-dom';

const SideBarMenu = ({ route, setMobileMenu }) => {
    // console.log(route)
    if (route?.chat) {
        return (
            <li className="sidebar-menu-item {{menuActive('admin.dashboard')}}">
                <a href={route.path} className="nav-link " target="_blank" onClick={() => setMobileMenu(true)}>
                    <i className={route.icon}></i>
                    <span className="menu-title">{route.name}  {route?.notification !== 0 && (
                        <span className="badge bg-danger">{route?.notification}</span>
                    )}</span>

                </a>

            </li>
        );
    }

    return (
        <li className="sidebar-menu-item {{menuActive('admin.dashboard')}}">
            <NavLink to={route.path} className="nav-link " onClick={() => setMobileMenu(true)}>
                <i className={route.icon}></i>
                <span className="menu-title">{route.name}</span>
            </NavLink>
        </li>
    );

};

export default SideBarMenu;